"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/components/auth/Auth";
import UserPageCollectedCard from "@/components/user/collected/cards/UserPageCollectedCard";
import { MEMES_CONTRACT } from "@/constants/constants";
import type { CollectedCard } from "@/entities/IProfile";
import { useNftBalance } from "@/hooks/useNftBalance";
import { ContractType } from "@/types/enums";
import { useMemo } from "react";
interface ArtistPrevoteCollectedCardProps {
  readonly card: CollectedCard;
}
export function ArtistPrevoteCollectedCard(t0) {
  const $ = _c(9);
  const {
    card
  } = t0;
  const {
    connectedProfile
  } = useAuth();
  const t1 = connectedProfile?.consolidation_key ?? null;
  let t2;
  if ($[0] !== card.token_id || $[1] !== t1) {
    t2 = {
      consolidationKey: t1,
      contract: MEMES_CONTRACT,
      tokenId: card.token_id
    };
    $[0] = card.token_id;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    balance: viewerBalance,
    isLoading: isViewerBalanceLoading
  } = useNftBalance(t2);
  const t3 = connectedProfile && !isViewerBalanceLoading ? viewerBalance : null;
  let t4;
  if ($[3] !== card || $[4] !== t3) {
    t4 = {
      ...card,
      seized_count: t3
    };
    $[3] = card;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const cardWithViewerBalance = t4;
  const t5 = !!connectedProfile && !isViewerBalanceLoading;
  let t6;
  if ($[6] !== cardWithViewerBalance || $[7] !== t5) {
    t6 = <div className="tw-flex tw-h-full tw-flex-col"><UserPageCollectedCard card={cardWithViewerBalance} contractType={ContractType.ERC1155} showDataRow={true} interactiveMode="link" showZeroSeizedCount={t5} copiesMax={0} qtySelected={0} selected={false} onToggle={_temp} onIncQty={_temp2} onDecQty={_temp3} /></div>;
    $[6] = cardWithViewerBalance;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}
function _temp3() {}
function _temp2() {}
function _temp() {}